<template>
  <div class="poster" ref="posterRoot">
    <div class="ph">
      <div class="ph1">DSA</div>
      <div class="ph2">DEEP SCHOLASTIC ASSESSMENT</div>
    </div>
    <div class="pbody">
      <div class="porg"><b>{{ institutionName }}</b> presents</div>
      <div class="psubj">{{ subjectName }}</div>
      <div class="pcat">
        <span v-if="category">{{ category }}</span>
        <span v-if="category && windowLabel"> · </span>
        <span v-if="windowLabel">{{ windowLabel }}</span>
      </div>
      <div v-if="blurbText" class="pblurb">{{ blurbText }}</div>
      <div class="pinfo">
        <div class="pc">
          <div class="pk">Enrollment closes</div>
          <div class="pv">{{ enrollmentClose || 'Published per window' }}</div>
        </div>
        <div class="pc">
          <div class="pk">Exam date</div>
          <div class="pv">{{ resolvedExamDate || 'Announced in calendar' }}</div>
        </div>
      </div>
    </div>
    <div class="pqr">
      <div class="pqrbox">
        <div ref="qr" class="poster-qr"></div>
        <div class="pqcap">Scan to apply for this exam</div>
      </div>
    </div>
    <div class="pf">DSA · 90-minute assessments · single 0–120 score · reports valid 5 years</div>
  </div>
</template>

<script>
import { ensureQrCodeLib } from '@/utils/institutionReg'

export default {
  name: 'DsaPoster',
  props: {
    institutionName: { type: String, default: 'Institution' },
    subjectName: { type: String, default: 'Subject' },
    category: { type: String, default: '' },
    major: { type: String, default: '' },
    windowLabel: { type: String, default: '' },
    enrollmentClose: { type: String, default: '' },
    examDate: { type: String, default: '' },
    /** @deprecated use examDate */
    examWindow: { type: String, default: '' },
    intro: { type: String, default: '' },
    registrationUrl: { type: String, required: true },
  },
  computed: {
    resolvedExamDate() {
      return this.examDate || this.examWindow || ''
    },
    blurbText() {
      const intro = String(this.intro || '').trim()
      if (intro) return intro
      return ''
    },
  },
  watch: {
    registrationUrl: {
      immediate: true,
      handler() {
        this.$nextTick(() => this.renderQr())
      },
    },
  },
  methods: {
    getRootEl() {
      return this.$refs.posterRoot
    },
    async renderQr() {
      const el = this.$refs.qr
      if (!el || !this.registrationUrl) return
      el.innerHTML = ''
      try {
        await ensureQrCodeLib()
        if (window.QRCode) {
          // eslint-disable-next-line no-new
          new window.QRCode(el, {
            text: this.registrationUrl,
            width: 170,
            height: 170,
            correctLevel: window.QRCode.CorrectLevel.M,
          })
          return
        }
      } catch (e) {
        /* fall through */
      }
      el.innerHTML = '<div class="qr-fallback">QR</div>'
    },
  },
}
</script>

<style scoped>
.poster{width:360px;background:#fff;border:1px solid #dbe2ea;border-radius:8px;overflow:hidden;font-family:-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;color:#1a202c;box-shadow:0 10px 30px rgba(15,40,80,.10)}
.ph{background:#185FA5;color:#fff;padding:14px 26px}
.ph1{font-size:15px;font-weight:700;letter-spacing:.06em}
.ph2{font-size:10.5px;opacity:.85;letter-spacing:.18em;margin-top:2px}
.pbody{padding:22px 26px 0}
.porg{font-size:12px;color:#5f6b7a;letter-spacing:.04em;border-bottom:1px solid #eef1f5;padding-bottom:14px}
.porg b{color:#185FA5;font-weight:600}
.psubj{font-size:25px;font-weight:700;line-height:1.2;margin-top:16px;color:#0C447C}
.pcat{font-size:12px;color:#5f6b7a;margin-top:6px}
.pblurb{font-size:12.5px;color:#4a5568;line-height:1.6;margin-top:14px}
.pinfo{display:flex;gap:10px;margin-top:16px}
.pc{flex:1;background:#F4F8FC;border:1px solid #e2ebf5;border-radius:8px;padding:10px 12px}
.pk{font-size:10.5px;color:#5f6b7a;letter-spacing:.03em;text-transform:uppercase}
.pv{font-size:13px;font-weight:600;color:#1a202c;margin-top:3px}
.pqr{text-align:center;padding:18px 26px 16px}
.pqrbox{width:196px;margin:0 auto;background:#fff;border:1px solid #dbe2ea;border-radius:8px;padding:12px}
.poster-qr{width:170px;height:170px;margin:0 auto;overflow:hidden}
.poster-qr >>> img,
.poster-qr >>> canvas{display:block}
.qr-fallback{width:170px;height:170px;display:flex;align-items:center;justify-content:center;background:#f4f8fc;color:#185FA5;font-weight:700;font-size:30px;letter-spacing:.1em}
.pqcap{font-size:12.5px;font-weight:600;color:#0C447C;margin-top:10px}
.pf{background:#f7f9fb;border-top:1px solid #eef1f5;padding:10px 26px;font-size:10px;color:#8a94a3;letter-spacing:.03em;text-align:center}
</style>
